import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsTT: CultureInfo = {
  name: 'es-TT',
  displayName: 'español (Trinidad y Tobago)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-TT',
  parent: CultureInfoEs
};
